import _ from 'lodash';
import * as actions from 'app/store/actions/glowforge-store';
import { PROMISE_ERROR } from 'app/common/actions/common';

export default function(state = {}, action) {
  switch (action.type) {
    case actions.SET_GLOWFORGE_ORDER_CONTENTFUL_PAGE: {
      return Object.assign({}, state, {
        page: action.result,
      });
    }
    case actions.SET_GLOWFORGE_PRODUCT_LIST: {
      return Object.assign({}, state, {
        products: _.get(action.result, 'products'),
      });
    }
    case actions.SET_COMPARISON_DATA: {
      return Object.assign({}, state, {
        comparisonData: action.result,
      });
    }
    case actions.SET_CONFIRMATION_PAGE: {
      return Object.assign({}, state, {
        orderConfirmationPage: _.get(action, 'result.fields'),
      });
    }
    case PROMISE_ERROR: {
      switch (_.get(action, 'error.type')) {
        case actions.ORDER_SUBMIT_ERROR: {
          return Object.assign({}, state, {
            submittingOrder: false,
          });
        }
        case actions.ORDER_TOTALS_ERROR: {
          return Object.assign({}, state, {
            gettingOrderTotals: false,
            orderTotals: null,
          });
        }
        default: {
          return state;
        }
      }
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/store/reducers/glowforge-store.js